import { Component } from '@angular/core';

@Component({
	selector: 'app-required-action',
	templateUrl: './required-action.component.html',
	styleUrls: ['./required-action.component.css'],
	standalone: false,
})
export class RequiredActionComponent {
	constructor() {}
}
